import { ChangeDetectionStrategy, Component, input, OnInit } from '@angular/core';
import {
	Product,
	UniversitySection,
	UniversitySectionLabel,
} from '@uc/web/shared/data-models';
import { UNI_SECTION_KEY_LIST } from '../../static/university.properties';
import { UniversitySectionNavigationComponent } from '../university-section-navigation/university-section-navigation.component';
import { UniversitySectionCardComponent } from '../university-section-card/university-section-card.component';

@Component({
	selector: 'uc-university-section',
	templateUrl: './university-section.component.html',
	imports: [UniversitySectionNavigationComponent, UniversitySectionCardComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UniversitySectionComponent implements OnInit {
	uniName = input.required<string>();
	universitySection = input<UniversitySection>({});
	heading = input<string>();
	externalUrl = input<string | undefined>();
	uniId = input<number | null>(null);
	product = input<Product | null>(null);
	ugSearchOrderPosition = input.required<number | null>();
	labels: UniversitySectionLabel = {} as UniversitySectionLabel;
	selectedKey!: string;

	ngOnInit(): void {
		this.filterKeys(this.universitySection());

		this.selectedKey = Object.keys(this.labels)[0];
	}

	/**
	 * Filters the objects that don't have image && text
	 * @example {key: {image: 'some value', text: ''}} because text is empty the object will be filtered out
	 * @returns the keys of objects that have image && text
	 */
	filterKeys(universitySection: UniversitySection) {
		Object.entries(universitySection).forEach((section) => {
			if (section[1].image && section[1].text) {
				const label =
					UNI_SECTION_KEY_LIST[section[0] as keyof typeof UNI_SECTION_KEY_LIST];
				this.labels[section[0]] = label;
				universitySection[section[0]] = {
					...section[1],
					label: label,
				};
			}
		});
	}

	onSelectKey(key: string): void {
		this.selectedKey = key;
	}
}
